import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/vercel/path0/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/src/components/theme-provider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/components/ui/sonner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyPlatformProvider"] */ "/vercel/path0/src/contexts/myPlatformContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvier"] */ "/vercel/path0/src/contexts/notificationContext.jsx");
